import { render } from "./ChangeSummaryItem.vue?vue&type=template&id=036b4586&scoped=true"
import script from "./ChangeSummaryItem.vue?vue&type=script&lang=js"
export * from "./ChangeSummaryItem.vue?vue&type=script&lang=js"

import "./ChangeSummaryItem.vue?vue&type=style&index=0&id=036b4586&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036b4586"]])

export default __exports__